import { updateInhabitantAddress } from '../../../../../api'
import { useNotification } from '../../../../../hooks'
import { useContractFormModal } from '../../../../Contract'
import {
  toUserSelectItem,
  UserEditAddressFormModal,
  UserProfileTabId,
  useUserProfileContext,
} from '../../../../User'
import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'

export function useUserProfilePageCreateContractAction({
  handlePerformMassAction,
}) {
  const {
    handleCloseModal,
    handleEntityReload,
    handleReloadTabs,
    setModal,
    userData,
  } = useUserProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleOpenCreation } = useContractFormModal()

  async function handleReloadContracts() {
    return handleReloadTabs([UserProfileTabId.Contracts])
  }

  function handleSubmitAddress(value) {
    updateInhabitantAddress({ id: userData.id, value })
      .then(() => {
        handleCloseModal()
        handleEntityReload()
        // Linking a flat auto-creates a contract on the backend.
        handleReloadContracts()
        handleAddSuccessNotification('Notification.CommonTitleSavedKey')
      })
      .catch(() => {
        handleCloseModal()
        handleAddErrorNotification(
          'Notification.InhabitantChangeAddressErrorKey'
        )
      })
  }

  function handleArchiveWithoutFlats() {
    handlePerformMassAction({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive,
      isArchived: false,
    })
  }

  function handleOpenEditAddressModal() {
    setModal(
      <UserEditAddressFormModal
        ownerId={userData.id}
        permissions={userData.permissions}
        onArchive={handleArchiveWithoutFlats}
        onClose={handleCloseModal}
        onSubmit={handleSubmitAddress}
      />
    )
  }

  function handleOpenCreateContract() {
    handleOpenCreation({
      initialUser: userData ? toUserSelectItem(userData) : null,
      setModal,
      onClose: handleCloseModal,
      onEntityReload: handleEntityReload,
      onReloadList: handleReloadContracts,
    })
  }

  return { handleOpenCreateContract, handleOpenEditAddressModal }
}
